import Step1 from '../../assets/images/Job Description Generator_2.png'
import Step2 from '../../assets/images/Multi Language Support.png'
import Step3 from '../../assets/images/Job Description Builder_2.svg'
import Step4 from '../../assets/images/Post a job to job boards.png'
import StepsArrow from '../../assets/images/StepsArrow.svg'
import StepsArrow2 from '../../assets/images/StepsArrow2.svg'
import CSS from './styles.module.css'

// Animate on Scroll
import AOS from 'aos'
import 'aos/dist/aos.css'
import { useEffect } from 'react'
import Button from '../Button/Button'

const StepsContent = () => {
  useEffect(() => {
    AOS.init({ duration: 500, delay: 0 })
  }, [])

  return (
    <div className={CSS.StepsContentContainer} data-aos="fade-up">
      <div className={CSS.StepsContent}>
        <div className={CSS.Heading}>
          <h2>How to use our AI tool for creating job descriptions?</h2>
        </div>

        <div className={CSS.Steps} data-aos="fade-up">
          <div className={CSS.ArrowBG}>
            <img src={StepsArrow} alt="step" />
          </div>
          <div className={`${CSS.Content}`}>
            <h3>
              <font>> Step 1</font>Enter Details into the Job Description
              Builder
            </h3>
            <p>
              Simply input the job title for the role you're hiring for. To get
              an even more tailored AI-generated job description, you can add
              optional details like your <b>"Company Name"</b> and{' '}
              <b>"Company Industry."</b> Click <b>"Generate JD"</b>, and get
              your job description instantly.
            </p>
          </div>
          <div className={`${CSS.StepsImg} ${CSS.right}`}>
            <img src={Step1} alt="Job Description Generator" />
          </div>
        </div>

        <div className={CSS.Steps} data-aos="fade-up">
          <div className={CSS.ArrowBG}>
            <img src={StepsArrow2} alt="step" />
          </div>
          <div className={`${CSS.StepsImg}`}>
            <img src={Step2} alt="Job Description Builder" />
          </div>
          <div className={`${CSS.Content} ${CSS.cRight}`}>
            <h3>
              <font>
                > Step 2 <span>(Optional)</span>
              </font>
              Choose a Language
            </h3>
            <p>
              Reach a global talent pool with ease. Our free AI job description
              generator supports multiple languages, including{' '}
              <b>
                English (US), English (UK), Spanish, German, French, Arabic,
                Portuguese, Polish, and Italian.
              </b>
            </p>
          </div>
        </div>

        <div className={CSS.Steps} data-aos="fade-up">
          <div className={CSS.ArrowBG}>
            <img src={StepsArrow2} alt="step" />
          </div>
          <div className={`${CSS.Content}`}>
            <h3>
              <font>> Step 3</font>Generate and Refine Your Custom Job
              Description
            </h3>
            <p>
              Once generated, your comprehensive job description is ready. You
              can<b> copy</b>{' '} it with a single click and use it immediately.
              Need to make adjustments? The intuitive editor allows you to{' '}
              <b>tweak</b>,{' '} <b>customize</b>, and add specific details in
              seconds, ensuring the final output perfectly aligns with your
              company culture and role requirements.
            </p>
          </div>
          <div className={`${CSS.StepsImg} ${CSS.right}`}>
            <img src={Step3} alt="Job Description Builder" />
          </div>
        </div>

        <div className={CSS.Steps} data-aos="fade-up">
          <div className={`${CSS.StepsImg}`}>
            <img src={Step4} alt="Post a job to 250+ job boards" />
          </div>
          <div className={`${CSS.Content} ${CSS.cRight}`}>
            <h3>
              <font>
                > Step 4 <span>(Optional)</span>
              </font>
              Post your JD to 250+ Job Boards
            </h3>
            <p>
              We help you reach millions of great candidates for your open role.
              With Recooty, you can <b>post</b> your perfectly tailored job
              description to over <b>250 world-class job boards</b> and hire
              great people for every role.
            </p>
            <div className={CSS.ActionButton}>
              <a href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Frecooty.com%2F">
                <Button variant="HeroButton" leftIcon="send">
                  Post Your Job for Free
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StepsContent
